import { useState, useEffect } from "react";
import image_placeholder from "../../img/img_placeholder.svg";

const LazyImg = (props: any) => {
    const { src, thumb, className, style, alt, ...rest } = props;

    // If src matches thumb or no thumb is provided, we use src immediately.
    // This avoids double-loading the same URL.
    const shouldUseSrcImmediately = !thumb || src === thumb;
    
    const [imgSource, setImgSource] = useState(shouldUseSrcImmediately ? (src || image_placeholder) : thumb);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // Only preload high-quality image if we are currently showing a different thumbnail
        if (!shouldUseSrcImmediately && src && imgSource !== src) {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                setImgSource(src);
                setLoaded(true);
            };
        }
    }, [src, thumb, shouldUseSrcImmediately, imgSource]);

    const handleLoad = () => {
        // If the current image source matches the specific high-quality src,
        // or if we treated them as the same, we consider it fully loaded.
        if (imgSource === src || shouldUseSrcImmediately) {
            setLoaded(true);
        }
    };

    return (
        <img
            className={`lazy-img ${className || ""}`}
            style={{
                ...style,
                filter: !loaded ? "blur(10px)" : "none",
                transition: "filter 0.3s ease-out",
            }}
            onLoad={handleLoad}
            onError={() => setImgSource(image_placeholder)}
            src={imgSource}
            alt={alt}
            loading="lazy"
            {...rest}
        />
    );
};

export default LazyImg;
